export const CHECKED_BAG_KEBAB_CASE = 'checked-bag';
export const CHECKED_BAG_CAMEL_CASE = 'checkedBag';
export const CHECKED_BAG_UPPER_CASE = 'CHECKED_BAG';

export const CABIN_BAG_KEBAB_CASE = 'cabin-bag';
export const CABIN_BAG_CAMEL_CASE = 'cabinBag';
export const CABIN_BAG_UPPER_CASE = 'CABIN_BAG';

export const kebabToCamelCaseMap = {
  [CHECKED_BAG_KEBAB_CASE]: CHECKED_BAG_CAMEL_CASE,
  [CABIN_BAG_KEBAB_CASE]: CABIN_BAG_CAMEL_CASE,
} as const;

export const camelCaseToKebabCaseMap = {
  [CHECKED_BAG_CAMEL_CASE]: CHECKED_BAG_KEBAB_CASE,
  [CABIN_BAG_CAMEL_CASE]: CABIN_BAG_KEBAB_CASE,
} as const;

export const camelToUpperCaseMap = {
  [CHECKED_BAG_CAMEL_CASE]: CHECKED_BAG_UPPER_CASE,
  [CABIN_BAG_CAMEL_CASE]: CABIN_BAG_UPPER_CASE,
} as const;

export const kebabToUpperCaseMap = {
  [CABIN_BAG_KEBAB_CASE]: CABIN_BAG_UPPER_CASE,
  [CHECKED_BAG_KEBAB_CASE]: CHECKED_BAG_UPPER_CASE,
} as const;

const kebabToCamelLookup = new Map<string, string>(Object.entries(kebabToCamelCaseMap));
const camelToKebabLookup = new Map<string, string>(Object.entries(camelCaseToKebabCaseMap));

export const kebabToCamel = (attr: string): string => kebabToCamelLookup.get(attr) ?? attr;
export const camelToKebab = (attr: string): string => camelToKebabLookup.get(attr) ?? attr;
